import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { withStyles, Grid, Typography, Paper } from '@material-ui/core';
import { ExpansionPanel } from '../../../../../../forms/form-components/expansion-panel/expansion-panel';
import styles, { StyledComponent } from '../../../../../../styles/styles';
import { LabeledValue } from '../../../../../../controls/labeled-value';
import { State } from '../../../../../../redux/root-reducer';
import { getFormDetails } from '../../form-details-reducer';
import { FormDetails } from '../../form-details-reducer';
import { OpenModal, openModalAction } from '../../../../../../form-modal/actions';
import { getClaim } from '../../../../../../claim';

interface BaseProps {
    formDetails?: FormDetails;
}

interface Props extends BaseProps, StyledComponent {
    readonly openModal: OpenModal;
}

const ClaimTypeDetailsViewComponent: React.FunctionComponent<Props> = ({
    classes,
    formDetails,
}: Props) => {
    let claimTypes = '';
    if (formDetails?.claimType) {
        claimTypes = formDetails.claimType;
        claimTypes = claimTypes
            .toString()
            .split(' ')
            .map(w => w[0].toUpperCase() + w.slice(1).replace(',', ', '))
            .join(' ');
    }
    return (
        <ExpansionPanel name="Claim type Details" style={{ marginLeft: -24, marginRight: -24 }}>
            <React.Fragment>
                <Grid container justify="space-between" className={classes.marginTop2}>
                    <Grid container item xs={10} alignItems="center">
                        <Typography
                            style={{ padding: 10 }}
                            className={classes.heading}
                            variant="body1"
                        >
                            Claim Type Details
                        </Typography>
                    </Grid>
                </Grid>
                <Paper className={classes.paper}>
                    <Grid container justify="flex-start">
                        <Grid item xs={12} container justify="flex-start">
                            <Grid item xs={12} lg={12}>
                                {formDetails?.claimType && (
                                    <LabeledValue label="Claim Type" value={claimTypes} />
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            </React.Fragment>
        </ExpansionPanel>
    );
};

const mapStateToProps = (state: State, ownProps: BaseProps) => ({
    formDetails: ownProps.formDetails || getFormDetails(state),
    openModal: openModalAction,
    claimType: getClaim(state).claimType,
});

const mapDispatchToProps = {
    openModal: openModalAction,
};

export const ClaimTypeDetailsView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(ClaimTypeDetailsViewComponent));
